import { create } from "zustand";
import createConversationSlice, {
  ConversationSlice,
} from "./slices/conversationSlice";
import createSignInPopUpSlice, {
  SignInPopUpSlice,
} from "./slices/signInPopupSlice";
import createAnswerSlice, { AnswerSlice } from "./slices/answerSlice";
import createChatHistorySlice, {
  ChatHistorySlice,
} from "./slices/chatHistorySlice";
import createCitationSlice, { CitationSlice } from "./slices/citationSlice";
import createErrorSlice, { ErrorSlice } from "./slices/errorSlice";
import createLoadingSlice, { LoadingSlice } from "./slices/loadingSlice";
import createPageSlice, { PageSlice } from "./slices/pageSlice";
import createQuestionSlice, { QuestionSlice } from "./slices/questionSlice";
import createUserSlice, { UserSlice } from "./slices/userSlice";

const useBoundStore = create<
  ConversationSlice &
    SignInPopUpSlice &
    ChatHistorySlice &
    CitationSlice &
    ErrorSlice &
    LoadingSlice &
    PageSlice &
    AnswerSlice &
    QuestionSlice &
    UserSlice
>()((...a) => ({
  ...createAnswerSlice(...a),
  ...createConversationSlice(...a),
  ...createChatHistorySlice(...a),
  ...createCitationSlice(...a),
  ...createErrorSlice(...a),
  ...createLoadingSlice(...a),
  ...createPageSlice(...a),
  ...createSignInPopUpSlice(...a),
  ...createQuestionSlice(...a),
  ...createUserSlice(...a),
}));

export default useBoundStore;
